export class CorporateEntitySearchResultModel {

    CorporateEntityIdentifier: number;
    CorporateEntityName: string;
    CorporateEntityNameAnonymous: string;
    PeerGroupName: string;
    PeerGroupIncludeFlag: boolean;
}
